
import { IconButton, Typography } from "@mui/material"
import { iconCellImport } from "branch/pages/ShippingProcess/columns"
import { shippingInvoiceColNm } from "branch/pages/ShippingProcess/constant"
import { BoxFR } from "components/BoxCustom"
import { jobOrderColNm } from "constants/jobOrderConstant"
import { ArticleRounded, PrintRounded } from "resource/muiImport"
import { numberFormat } from "utils"


export const shippingColumnsEnd = ({ handleFileClick, handlePrintDriver
  , onFileUploadSuccess, handlePrintExpense }) => [
    {
      field: 'LicNm',
      cellClassName: "normal-col",
      headerName: jobOrderColNm.LicNm,
      width: 100,
    },
    {
      field: 'NumJobOrd',
      cellClassName: "normal-col",
      headerName: 'จำนวนตู้',
      align: 'center',
      valueGetter: (params) => `${params.row.NumJobOrd}`,
      width: 70,
    },
    {
      field: 'NumHasDrvId',
      cellClassName: "normal-col",
      headerName: 'แจ้งรถ',
      align: 'center',
      valueGetter: (params) => `${params.row.NumHasDrvId}/${params.row.NumJobOrd}`,
      width: 70,
    },
    {
      field: 'PrintDrv',
      cellClassName: "normal-col",
      headerName: 'Print',
      align: 'center',
      width: 70,
      renderCell: ({ row }) => (
        <IconButton sx={{ p: 0 }} onClick={() => handlePrintDriver(row)}>
          <PrintRounded color="primary" />
        </IconButton>
      )
    },
    {
      field: 'NumContNo',
      cellClassName: "normal-col",
      headerName: 'ได้เบอร์ตู้',
      align: 'center',
      valueGetter: (params) => `${params.row.NumContNo}/${params.row.NumJobOrd}`,
      width: 70,
    },
    {
      field: 'NumArvTm',
      cellClassName: "normal-col",
      headerName: 'ถึง รง.',
      align: 'center',
      valueGetter: (params) => `${params.row.NumArvTm}/${params.row.NumJobOrd}`,
      width: 70,
    },
    {
      field: 'NumFinDte',
      cellClassName: "normal-col",
      headerName: 'งานจบ',
      align: 'center',
      valueGetter: (params) => `${params.row.NumFinDte}/${params.row.NumJobOrd}`,
      width: 70,
    },
    {
      field: 'JobOrderFiles',
      cellClassName: "normal-col",
      headerName: 'รูปตู้',
      width: 70,
      align: 'center',
      // valueGetter: (params) => params.value ? params.value.length : "0",
      renderCell: ({ id, value, row, field }) => {
        return (
          <BoxFR>
            {value?.length > 0 ? <Typography variant="body2">({value.length}) </Typography> : null}
            <IconButton sx={{ p: 0 }} onClick={value?.length > 0 ? handleFileClick(id, value, field, row) : null}>
              <ArticleRounded color={value?.length > 0 ? "primary" : "inherit"} />
            </IconButton>
          </BoxFR>
        )
      }
    },
    {
      field: 'ShFileNms',
      cellClassName: "normal-col",
      headerName: 'ไฟล์ ใบแจ้งลาก',
      width: 70,
      align: 'center',
      valueGetter: (params) => params.value ? params.value.length : "0",
      renderCell: iconCellImport({ handleFileClick, onFileUploadSuccess, shpFileTypId: null })
    },
    {
      field: 'BLFileNms',
      cellClassName: "normal-col",
      headerName: 'ไฟล์ก่อนเรือเข้า',
      width: 70,
      align: 'center',
      valueGetter: (params) => params.value ? params.value.length : "0",
      renderCell: iconCellImport({ handleFileClick, onFileUploadSuccess, shpFileTypId: 8, isUpdateTime: 0 })
    },
    {
      field: 'FRFileNms',
      cellClassName: "normal-col",
      headerName: 'ไฟล์สายเรือ',
      width: 70,
      align: 'center',
      valueGetter: (params) => params.value ? params.value.length : "0",
      renderCell: iconCellImport({ handleFileClick, onFileUploadSuccess, shpFileTypId: 10, isUpdateTime: 0 })
    },
    {
      field: 'CSFileNms',
      cellClassName: "normal-col",
      headerName: 'ไฟล์กรมศุลกากร',
      width: 70,
      align: 'center',
      valueGetter: (params) => params.value ? params.value.length : "0",
      renderCell: iconCellImport({ handleFileClick, onFileUploadSuccess, shpFileTypId: 14, isUpdateTime: 0 })
    },
    {
      field: 'Note',
      cellClassName: "normal-col",
      headerName: shippingInvoiceColNm.Note,
      width: 200,
    },
    {
      field: 'ScNm',
      cellClassName: "normal-col",
      headerName: shippingInvoiceColNm.ScId,
      width: 100,
    },
    {
      field: 'CostTotal',
      headerName: "รวมคชจ.",
      width: 100,
      valueGetter: ({ row }) => +(row.ItmPayAmnt || 0) + +(row.ScTotal || 0),
      valueFormatter: ({ value }) => value ? numberFormat(value) : "-",
      align: 'right',
    },
    {
      field: 'IncTotal',
      headerName: "รวมรายได้",
      width: 100,
      valueFormatter: ({ value }) => value ? numberFormat(value) : "-",
      align: 'right',
    },
    {
      field: 'GrssPfAmnt',
      headerName: "กำไรขั้นต้น",
      width: 100,
      valueGetter: ({ row }) => +(row.IncTotal || 0) - +(row.ItmPayAmnt || 0) - +(row.ScTotal || 0),
      valueFormatter: ({ value }) => value ? numberFormat(value) : "-",
      align: 'right',
    },
    // {
    //   field: 'LITCostTotal',
    //   headerName: "รวมคชจ. LIT",
    //   width: 100,
    //   valueGetter: ({ row }) =>  +(row.LITItmPayAmnt || 0) + +(row.LITScTotal || 0),
    //   valueFormatter: ({ value }) => value ? numberFormat(value) : "-",
    //   align: 'right',
    // },
    // {
    //   field: 'LITIncTotal',
    //   headerName: "รวมรายได้ LIT",
    //   width: 100,
    //   valueFormatter: ({ value }) => value ? numberFormat(value) : "-",
    //   align: 'right',
    // },
    // {
    //   field: 'LITGrssPfAmnt',
    //   headerName: "กำไรขั้นต้น LIT",
    //   width: 120,
    //   valueGetter: ({ row }) => +(row.LITIncTotal || 0) - +(row.LITItmPayAmnt || 0) - +(row.LITScTotal || 0),
    //   valueFormatter: ({ value }) => value ? numberFormat(value) : "-",
    //   align: 'right',
    // },
    // {
    //   field: 'TotalGrssPfAmnt',
    //   headerName: "รวมกำไรขั้นต้น",
    //   width: 100,
    //   valueGetter: ({ row }) => +(row.IncTotal || 0) - +(row.ItmPayAmnt || 0) - +(row.ScTotal || 0)
    //   +(row.LITIncTotal || 0) - +(row.LITItmPayAmnt || 0) - +(row.LITScTotal || 0),
    //   valueFormatter: ({ value }) => value ? numberFormat(value) : "-",
    //   align: 'right',
    // },
    {
      field: 'PrintExp',
      cellClassName: "normal-col",
      headerName: 'Print',
      align: 'center',
      width: 70,
      renderCell: ({ row }) => (
        <IconButton sx={{ p: 0 }} onClick={() => handlePrintExpense(row)}>
          <PrintRounded color="primary" />
        </IconButton>
      )
    },
    {
      field: 'Rmk',
      cellClassName: "normal-col",
      headerName: shippingInvoiceColNm.Rmk,
      minWidth: 200,
      flex: 1,
      editable: true,
    },
  ]